// @flow
import fp from "lodash/fp"
import * as R from "ramda"
import type {
  BaggageCategory,
  BaggageSubCategory,
  Combinations,
  Definition,
  Definitions,
} from "@kiwicom/nitro/lib/records/Baggage"

import Price from "common/records/Price"
import type { PassengerValues } from "booking/scenes/ReservationForm/services/fields/passengersFields"

export type CountBaggage = {
  [index: string]: number,
}

export const countBaggage = (
  baggageCategory: BaggageCategory,
  baggageSubCategory: BaggageSubCategory,
) => (
  combinations: Combinations,
  passengers: PassengerValues[],
  definitions: Definitions,
): CountBaggage =>
  R.compose(
    R.countBy(R.identity),
    mapped => [].concat(...mapped),
    R.map(passenger => {
      const combination = combinations[baggageCategory][
        passenger.baggage[baggageCategory]
      ].indices.filter(
        bagIndex => definitions[baggageCategory][bagIndex].category === baggageSubCategory,
      )

      return combination
    }),
  )(passengers)

export type PriceBaggage = {
  [index: string]: Price,
}

export const calculatePriceBaggage = (
  baggageCount: CountBaggage,
  baggageDefinitions: Definition[],
): PriceBaggage =>
  R.compose(
    R.reduce(
      (acc, key) =>
        fp.set(key, Price.sum(Array(baggageCount[key]).fill(baggageDefinitions[key].price)), acc),
      {},
    ),
    R.keys,
  )(baggageCount)

export const sumBaggagePrices = (baggagePrices: PriceBaggage): Price =>
  Price.sum(R.values(baggagePrices))
